import { Button, ButtonProps, Tooltip } from "@mui/material";
import * as React from "react";
import SyncIcon from "@mui/icons-material/Sync";
import { useLanguage } from "../../Language";
import { useWindowVariables } from "../../WindowVariables";
import { axios } from "../../AxiosInstanceManager";
import { AccountHolder, useAccount } from "../../Account";
import { SuccessMessageControl } from "@tlc/ls2pac/app/controls/successMessageControl";
import { SimpleErrorDialog } from "@tlc/ls2pac/app/controls/simpleErrorDialog";
import * as dayjs from "dayjs";

interface HistoryUpdateHistoryRequest {
  patronId: string;
}

interface EResourceHistoryResponse {
  success: boolean;
  thereAreChanges: boolean;
  lastUpdated: string; // Date
  messageToken: string;
}

interface UpdateDigitalLoansButtonProps extends ButtonProps {
    onUpdate?: () => void;
}

export const UpdateDigitalLoansButton: React.FC<UpdateDigitalLoansButtonProps> = ({onUpdate, ...props}) => {
  const { translate } = useLanguage();
  const { hasAuthorizedEResources } = useWindowVariables();
  const { patron, accountSummary } = useAccount();

  const [loading, setLoading] = React.useState<boolean>(false);
  const [timestamp, setTimestamp] = React.useState<string>(
    dayjs(accountSummary.digitalInformationLastUpdated).format("L LTS")
  );

  if (hasAuthorizedEResources) {
    return (
      <>
        <Tooltip
          title={`${translate("digitalInformationLastUpdated")}: ${timestamp}`}
        >
          <Button
            disabled={loading}
            onClick={async () => {
              setLoading(true);
              const payload: HistoryUpdateHistoryRequest = {
                patronId: patron.patronId,
              };
              const { data } = await axios.post<EResourceHistoryResponse>(
                `pacApi/updateHistory`,
                payload
              );
              setLoading(false);
              if (data.success) {
                const { lastUpdated } = data;
                SuccessMessageControl.show(
                  translate("digitalLoanUpdateSuccessMessage")
                );
                setTimestamp(dayjs(lastUpdated).format("L LTS"));
                await AccountHolder.fetchAccountData(true);
                if(onUpdate){
                    onUpdate();
                }
              } else {
                const { messageToken } = data;
                const message = messageToken
                  ? translate(messageToken)
                  : translate("digitalLoanUpdateFailureMessage");
                SimpleErrorDialog.show(message);
              }
            }}
            startIcon={<SyncIcon />}
          >
            {translate("updateDigitalInfo")}
          </Button>
        </Tooltip>
      </>
    );
  }

  return <></>;
};
